export const SAME_ORIGIN_IFRAME_COMM_CHANNEL_ID = '__SAME_ORIGIN_IFRAME_COMM_CHANNEL__';
//# sourceMappingURL=constants.js.map